<template>
  <Modal class="tagsModal mfdmodel newModal" v-model="value" title="分配客户" width="500px" :mask-closable="false" :closable="false">
    <div class="dwermodel">
      <div class="dw-item" v-for="(item,key) in list" :key="key">
        <Checkbox v-model="item.bo">{{item.value}}</Checkbox>
      </div>
    </div>
    <div class="drawer-footer" slot="footer">

      <div class="u-flex  footer-left">
        <Checkbox :indeterminate="indeterminate" @on-change="allselect" v-model="single">全选</Checkbox>
        <div>已选择{{bolen}}项</div>
      </div>
      <Button type="primary" @click="submitForm('formValidate')">提交</Button>
      <Button style="margin-right: 8px" @click="closeDrawer">取消</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    props: {
      value: {},
      clist: []
    },
    watch: {
       list:{
        deep:true,
        handler:function(value){
            let len=this.list.length
            let ar=this.list.filter(e=>e.bo).length
            if(len==ar){
                this.single=true
            }else{
              this.single=false  
            }
        }
       },
      value(value) {
        if (value) {
 
          this.list = JSON.parse(JSON.stringify(this.clist))
        }
      }
    },
    computed:{
        indeterminate(){
            let index=this.list.filter((e)=>e.bo).length
        
            if(index>0&&index<this.list.length){
                if(this.list.length==index){
                    this.single=true
                }
                return true
            }else{
                return false
            }
        },
        bolen(){
          return this.list.filter((e)=>e.bo).length
        },
    },
    data() {
      return {
        list: [],
        single: false
      }
    },
    methods: {
        submitForm(){
         let indarr=this.list.filter(e=>e.bo).map(e=>e.id)
         this.$emit('indarr',indarr)
        },
        allselect(index){
      
            this.list=this.list.map(e=>{
                e.bo=index
                return e
            })
        },
      closeDrawer() {
        this.$emit('input', false)
      },
    }
  }
</script>
<style>


</style>
<style>
  .mfdmodel .dw-item {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
  }

  .mfdmodel .drawer-footer {
    position: relative;
  }

 

  .mfdmodel .footer-left {
    position: absolute;
    left: 5px;
    font-size: 14px;
  }
</style>
<style lang="less" scoped>
 .dwermodel {
     max-height: 320px;
    overflow: auto;
  }

</style>